export const defaultRatioRightColumn = 0.35;
export const largeScreenRatioRightColumn = 0.4;
export const activitySidePanelRatio = 0.4;
export const getIssueContainerDefaultMaxWidth = () => 1680;
export const getIssueContainerIncreasedMaxWidth = () => 1920;
export const ACTIVITY_SIDE_PANEL_MIN_WIDTH = 400;
